import React, { useMemo } from "react";

/**
 * Props:
 *  - current: number | null
 *  - previous: number | null
 */
export default function MarketNowBadge({ current, previous }) {
  const info = useMemo(() => {
    const c = Number(current);
    const p = Number(previous);

    if (!Number.isFinite(c) || !Number.isFinite(p)) {
      return { state: "—", cls: "background:#f3f4f6;color:#111827;border:1px solid #e5e7eb" };
    }

    if (c > p) return { state: "UP", cls: "background:#ecfdf5;color:#065f46;border:1px solid #a7f3d0" };
    if (c < p) return { state: "DOWN", cls: "background:#fef2f2;color:#991b1b;border:1px solid #fecaca" };
    return { state: "FLAT", cls: "background:#f3f4f6;color:#374151;border:1px solid #e5e7eb" };
  }, [current, previous]);

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2px 8px",
        borderRadius: 999,
        fontSize: 12,
        fontWeight: 700,
        letterSpacing: 0.3,
        ...parseInlineCss(info.cls),
      }}
      title={
        Number.isFinite(Number(current)) && Number.isFinite(Number(previous))
          ? `prev: ${Number(previous).toFixed(4)} | now: ${Number(current).toFixed(4)}`
          : "No live price yet"
      }
    >
      {info.state}
    </span>
  );
}

function parseInlineCss(cssText) {
  // tiny helper to keep the badge readable without adding new css deps
  // format: "key:value;key:value"
  const out = {};
  String(cssText || "")
    .split(";")
    .map((s) => s.trim())
    .filter(Boolean)
    .forEach((pair) => {
      const [k, v] = pair.split(":").map((x) => x.trim());
      if (!k) return;
      const jsKey = k.replace(/-([a-z])/g, (_, c) => c.toUpperCase());
      out[jsKey] = v;
    });
  return out;
}
